import React, { useState } from "react";
import { ordersApi } from "../../services/api";

function EditModal({ order, onClose, onSave }) {
  const [customerName, setCustomerName] = useState(order.customer_name || "");
  const [customerPhone, setCustomerPhone] = useState(order.customer_phone || "");
  const [originalPhone, setOriginalPhone] = useState(order.original_phone || "");
  const [orderTotal, setOrderTotal] = useState(order.order_total || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSave = async () => {
    setSaving(true);
    setError("");
    try {
      const data = await ordersApi.updateOrder(order.id, {
        customerName, customerPhone, originalPhone, orderTotal,
      });
      if (data.success) onSave();
      else setError(data.error);
    } catch (err) {
      setError("Failed to save");
    }
    setSaving(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>Edit Order #{order.shopify_order_number}</h2>
        {error && <div className="error-msg">{error}</div>}
        <div className="form-group">
          <label>Customer Name</label>
          <input value={customerName} onChange={(e) => setCustomerName(e.target.value)} />
        </div>
        <div className="form-group">
          <label>Sent To Phone</label>
          <input value={customerPhone} onChange={(e) => setCustomerPhone(e.target.value)} />
        </div>
        <div className="form-group">
          <label>Original Customer Phone</label>
          <input value={originalPhone} onChange={(e) => setOriginalPhone(e.target.value)} placeholder="Real customer number" />
        </div>
        <div className="form-group">
          <label>Order Total</label>
          <input value={orderTotal} onChange={(e) => setOrderTotal(e.target.value)} />
        </div>
        <div style={{ display: "flex", gap: "8px", marginTop: "16px" }}>
          <button className="btn-primary" onClick={handleSave} disabled={saving} style={{ flex: 1 }}>
            {saving ? "Saving..." : "Save Changes"}
          </button>
          <button className="btn-secondary" onClick={onClose} style={{ flex: 1 }}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default EditModal;
